export default {
  methods: {
    closeProductDetailsModal() {
      this.$bvModal.hide("product-details-modal");
    }
  }
};

